import "../lib/sentry";
import "@hotwired/turbo-rails";
import { Application } from "@hotwired/stimulus";
import TextareaAutogrow from "stimulus-textarea-autogrow";
import axios from "axios";
import Clipboard from "@stimulus-components/clipboard";
import RailsNestedForm from "@stimulus-components/rails-nested-form";

const application = Application.start();
application.register("textarea-autogrow", TextareaAutogrow);
application.register("clipboard", Clipboard);
application.register("nested-form", RailsNestedForm);

window.application = application;

document.addEventListener("turbo:load", function () {
  function checkScrollPosition() {
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;
    const screenHeight = window.innerHeight;

    if (scrollPosition > 1.5 * screenHeight) {
      scrollTopArrow.classList.remove("translate-y-[200px]");
    } else {
      scrollTopArrow.classList.add("translate-y-[200px]");
    }
  }

  const scrollTopArrow = document.querySelector("#scrollTopArrow");
  if (scrollTopArrow) {
    checkScrollPosition();
    window.addEventListener("scroll", checkScrollPosition);

    scrollTopArrow.addEventListener("click", function () {
      const top = document.querySelector("[data-controller='deal_layout']")
        ? 310
        : 0;
      window.scrollTo({ top: top, behavior: "smooth" });
    });
  }
});

function pathToControllerName(path, pattern) {
  let match;

  if (pattern === "components") {
    match = path.match(/components\/(.+)\/controller\.(js|jsx|ts|tsx)$/);
  } else if (pattern === "packs") {
    // packs/<pack_name>/app/components/<path>/controller.tsx -> <path>
    // packs/<pack_name>/app/frontend/components/<path>/controller.tsx -> <path>
    match = path.match(
      /packs\/[^/]+\/app\/(?:frontend\/)?components\/(.+)\/controller\.(js|jsx|ts|tsx)$/,
    );
  } else {
    match = path.match(/controllers\/(.+)_controller\.(js|jsx|ts|tsx)$/);
  }

  if (!match) return null;

  return match[1].replaceAll("_", "-").replaceAll("/", "--");
}

function registerControllers(controllers, pattern) {
  for (let path in controllers) {
    const module = controllers[path];
    const name = pathToControllerName(path, pattern);
    if (name) {
      application.register(name, module.default);
    }
  }
}

// ViewComponents' controllers (app/components/)
const componentControllers = import.meta.glob(
  "../../components/**/controller.{js,jsx,ts,tsx}",
  { eager: true },
);

// Pack components' controllers (packs/*/app/components/ and packs/*/app/frontend/components/)
const packControllers = import.meta.glob(
  [
    "@packs/*/app/components/**/controller.{js,jsx,ts,tsx}",
    "@packs/*/app/frontend/components/**/controller.{js,jsx,ts,tsx}",
  ],
  { eager: true },
);

// Standalone controllers (app/frontend/controllers/)
const frontendControllers = import.meta.glob(
  "../controllers/**/*_controller.{js,jsx,ts,tsx}",
  { eager: true },
);

registerControllers(componentControllers, "components");
registerControllers(packControllers, "packs");
registerControllers(frontendControllers, "frontend");

function setupCsrf() {
  // Configure axios defaults
  const csrfToken = document
    .querySelector('meta[name="csrf-token"]')
    ?.getAttribute("content");
  if (csrfToken) {
    axios.defaults.headers.common["X-CSRF-Token"] = csrfToken;
  }
  //axios.defaults.headers.common["Accept"] = "application/json";
  //axios.defaults.headers.common["Content-Type"] = "application/json";
}

document.addEventListener("DOMContentLoaded", () => {
  setupCsrf();
});

setupCsrf();
